import { FEATURE_NAME } from './reducerPaths';

export const SUBMIT_USER_START: string = `${FEATURE_NAME}/SUBMIT_USER_START`;
export const SUBMIT_USER_COMPLETE: string = `${FEATURE_NAME}/SUBMIT_USER_COMPLETE`;
export const SUBMIT_USER_ERROR: string = `${FEATURE_NAME}/SUBMIT_USER_ERROR`;
